<template>
  <b-row class="mt-3">
    <b-form-group class="w-100">
      <template #label>
        <font-awesome-icon :icon="['far', 'sticky-note']" class="text-muted" fixed-width />
        <span class="configurator-label">{{  label }}</span>
      </template>
      <transition name="fade">
        <b-textarea
          :value="value"
          rows="3"
          size="lg"
          trim
          @input="update"
        />
      </transition>
    </b-form-group>
  </b-row>
</template>

<script>
export default {
  name: 'StepNotes',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: 'Notas generales'
    }
  },
  methods: {
    update (val) {
      this.$emit('update-form', val)
    }
  }
}
</script>